import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import Hls from 'hls.js';

@Directive({
    selector: '[appHlsVideo]',
    standalone: true,
})
export class HlsVideoDirective implements OnChanges, OnDestroy {
    @Input() appHlsVideo: string | undefined = '';

    private hls?: Hls;

    constructor(private el: ElementRef<HTMLVideoElement>) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['appHlsVideo']) {
            this.load(this.appHlsVideo);
        }
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    private load(src: string | undefined): void {
        const video = this.el.nativeElement;
        this.destroy();

        if (!src || typeof window === 'undefined' || !Hls.isSupported()) {
            return;
        }

        const isHls = (() => {
            try {
                return new URL(src, window.location.href).pathname.endsWith('.m3u8');
            } catch {
                return src.endsWith('.m3u8');
            }
        })();

        if (!isHls) {
            return;
        }

        this.hls = new Hls();
        this.hls.on(Hls.Events.ERROR, (_event, data) => {
            if (data.fatal) {
                video.dispatchEvent(new Event('error'));
            }
        });
        this.hls.loadSource(src);
        this.hls.attachMedia(video);
    }

    private destroy(): void {
        this.hls?.destroy();
        this.hls = undefined;
    }
}
